var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3335,
    cy: 15.6016,
    r: 14.5,
    fill: "#F4F6FE",
    stroke: "#1737E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9138 18.0287L18.5333 17.8711C18.2018 17.8331 17.8757 17.9472 17.642 18.1809L16.642 19.1809C15.104 18.3983 13.8431 17.1428 13.0605 15.5994L14.0659 14.5939C14.2996 14.3602 14.4138 14.0341 14.3757 13.7026L14.2181 12.3331C14.1529 11.7841 13.6909 11.3711 13.1366 11.3711H12.1964C11.5822 11.3711 11.0714 11.882 11.1094 12.4961C11.3975 17.1374 15.1094 20.8439 19.7453 21.132C20.3594 21.17 20.8703 20.6591 20.8703 20.045V19.1048C20.8757 18.5559 20.4627 18.0939 19.9138 18.0287Z",
    fill: "#1737E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGroup);
export default __webpack_public_path__ + "static/media/callGroup.7d9675189a947483f3d8aa765d0afa59.svg";
export { ForwardRef as ReactComponent };